import { gql } from '@apollo/client'

export const GET_PAGED_VEHICLES = gql`
  query GetPagedVehicles(
    $driverId: Long!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $order: [VehicleSortInput!]
    $where: VehicleFilterInput
  ) {
    vehicles(
      driverId: $driverId
      after: $after
      before: $before
      first: $first
      last: $last
      order: $order
      where: $where
    ) {
      edges {
        node {
          id
          colour
          registrationNumber
          manufacturer
          model
          dateOfManufacture
          vehicleType {
            id
            name
          }
          assignedDrivers {
            id
          }
        }
      }

      totalCount
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
`

export const GET_VEHICLE_QUERY = gql`
  query GetVehicle($driverId: Long!, $vehicleId: Long!) {
    vehicle(driverId: $driverId, vehicleId: $vehicleId) {
      id
      driverId
      vehicleTypeId
      vehicleType {
        id
        name
      }
      manufacturer
      dateOfManufacture
      model
      colour
      insuranceCompany
      insuranceExpiryDate
      motTestExpiryDate
      isRenewalReminder
      registrationNumber
      policyOrCoverNote
      goodsInTransitExpiryDate
      bodyType
      hasTailLift

      assignedDrivers {
        id
      }

      vehicleSpecialServices {
        id
        vehicleId
        specialServiceId
      }
    }
  }
`

export const GET_VEHICLE_TYPES_QUERY = gql`
  query GetVehicleTypes($order: [VehicleTypeSortInput!]) {
    vehicleTypes(order: $order) {
      id
      name
      isEnabled
    }
  }
`

export const GET_VEHICLE_BODY_TYPES_QUERY = gql`
  query GetVehicleBodyTypes {
    vehicleBodyTypes {
      id
      description
      bodyType
    }
  }
`

export const GET_SPECIAL_SERVICES_QUERY = gql`
  query GetSpecialServices {
    specialServices {
      id
      name
    }
  }
`

export const VEHICLE_PRE_DELETE_VALIDATION_QUERY = gql`
  query vehiclePreDeleteValidation($driverId: Long!, $vehicleId: Long!) {
    vehicle(vehicleId: $vehicleId, driverId: $driverId) {
      id
      hasBids
    }
  }
`
